// extracted by mini-css-extract-plugin
module.exports = {"component":"State_component__2k7ry","icon":"State_icon__j6b4K","content":"State_content__1kyZX"};